import { useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useGetBusinessPlansLimits = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: businessPlanQueryKeys.businessPlansLimits(),
    queryFn: () => {
          return new Promise((resolve) => {
            setTimeout(async () => {
              const result = await BusinessPlanApi.getLimits();
              resolve(result);
            }, 250);
          });
        },
    enabled,
  });
};
